import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import sareePileSrc from "../../assets/saree-pile.jpeg";

export default function Landing() {
  return (
    <section className="max-w-7xl mx-auto px-6 pt-10 pb-24 grid md:grid-cols-12 gap-10 items-center">
      <div className="md:col-span-7">
        <span className="inline-block text-xs font-semibold tracking-wide uppercase px-3 py-1.5 rounded-full mb-6" style={{ background: "var(--surface-tint)", color: "var(--primary-hover)" }}>
          Built for saree &amp; dress sellers in India
        </span>
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="landing-hero-title">
          Move your saree business off <span style={{ color: "var(--primary)" }}>notebooks & Excel</span>.
        </h1>
        <p className="mt-6 text-lg leading-relaxed max-w-xl" style={{ color: "var(--text-muted)" }}>
          VastraKiran is the simplest inventory and billing app for home-run boutiques. Print a barcode for every piece, scan to bill, and know your revenue in one glance. GST-ready. 14-day free trial.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/register" data-testid="landing-hero-cta" className="inline-flex items-center gap-2 px-6 py-4 rounded-md text-white text-base font-semibold tactile-btn" style={{ background: "var(--primary)" }}>
            Start 14-day free trial <ArrowRight size={18} />
          </Link>
          <Link to="/login" data-testid="landing-hero-signin" className="inline-flex items-center gap-2 px-6 py-4 rounded-md text-base font-semibold border" style={{ borderColor: "var(--border-soft)" }}>
            I already have an account
          </Link>
        </div>
        <div className="mt-8 flex items-center gap-6 text-sm" style={{ color: "var(--text-muted)" }}>
          <div>✓ No credit card</div>
          <div>✓ GST invoices</div>
          <div>✓ INR (₹)</div>
        </div>
      </div>
      <div className="md:col-span-5">
        <div className="relative">
          <img
            src={sareePileSrc}
            alt="Sarees"
            className="w-full h-[480px] object-cover rounded-2xl border"
            style={{ borderColor: "var(--border-soft)" }}
          />
          <div className="absolute -bottom-6 -left-6 card-soft p-4 w-64 hidden sm:block">
            <div className="text-xs" style={{ color: "var(--text-muted)" }}>Today&apos;s revenue</div>
            <div className="font-display font-bold text-2xl num" style={{ color: "var(--primary)" }}>₹ 42,650</div>
            <div className="text-xs mt-1" style={{ color: "var(--success)" }}>▲ 18% from yesterday</div>
          </div>
        </div>
      </div>
    </section>
  );
}
